import type { CatalogCategoryId, CatalogInputKind, ExternalCatalogEntry } from "../contracts/catalog";
import type { ExternalGameLaunchMode } from "./external-game-launch";
import js13kCatalog from "./js13k-catalog.generated.json" with { type: "json" };

export interface CuratedWebExternalGameLink {
  readonly slug: string;
  readonly title: string;
  readonly url: `https://${string}`;
  readonly coverUrl: string;
  readonly launchMode: ExternalGameLaunchMode;
  readonly source?: "web" | "js13k";
  readonly sourceItemId?: string;
  readonly categories?: readonly CatalogCategoryId[];
  readonly inputs?: readonly CatalogInputKind[];
  readonly receiptRef?: string;
  readonly reviewedAt?: string;
}

/** Generated only from explicit review receipts by scripts/catalog-js13k.mjs. */
const JS13K_EXTERNALS = js13kCatalog as readonly CuratedWebExternalGameLink[];

/** Reviewed official destinations, not CARCADE-owned or rehosted games. */
export const CURATED_WEB_EXTERNALS: readonly CuratedWebExternalGameLink[] = [
  {
    slug: "cursor-camp",
    title: "Cursor Camp",
    url: "https://neal.fun/cursor-camp/",
    coverUrl: "/external/cursor-camp.svg",
    launchMode: "navigate",
  },
  ...JS13K_EXTERNALS,
];

const CURATED_WEB_BY_SLUG = new Map<string, CuratedWebExternalGameLink>(
  CURATED_WEB_EXTERNALS.map((game) => [game.slug, game]),
);

export function curatedWebLaunchMode(slug: string): ExternalGameLaunchMode | undefined {
  return CURATED_WEB_BY_SLUG.get(slug)?.launchMode;
}

/** Same source identity and category metadata for the launcher and read-only API. */
export function curatedWebCatalogEntries(): readonly ExternalCatalogEntry[] {
  return CURATED_WEB_EXTERNALS.map((game) => {
    const source = game.source ?? "web";
    const sourceItemId = game.sourceItemId ?? game.slug;
    const catalogId = `${source}:${sourceItemId}`;
    const asOf = Date.parse(game.reviewedAt ?? "2026-09-03T00:00:00Z");
    return {
      kind: "external",
      catalogId,
      groupId: catalogId,
      source,
      sourceItemId,
      title: game.title,
      description: null,
      cover: { status: "present", url: game.coverUrl },
      categories: game.categories ?? ["other"],
      players: { status: "unknown" },
      inputs: game.inputs ?? [],
      offline: "online-only",
      status: "active",
      launch: { url: game.url, slug: game.slug },
      receiptRef: game.receiptRef ?? "wiki/delivery/2026-09-03-cursor-camp-visible-launcher.md",
      createdAt: asOf,
      updatedAt: asOf,
    };
  });
}
